import { MyNaviButton } from '@/components/Campaign/mynavi/MyNaviButton/MyNaviButton'
import { MyNaviTypography } from '@/components/Campaign/mynavi/MyNaviUI/MyNaviTypography'
import { IconX } from '@tabler/icons-react'
import type { ReactNode } from 'react'

export type MyNaviFilterLayoutProps = {
  title: string
  onClose: () => void
  children: ReactNode
  /** null = ローディング中（空白表示） */
  searchResultCount: number | null
  onSelect: () => void
  onClear: () => void
}

export function MyNaviFilterLayout({
  title,
  onClose,
  children,
  searchResultCount,
  onSelect,
  onClear,
}: MyNaviFilterLayoutProps) {
  return (
    <div className="flex flex-col bg-[#fbfbfb]" style={{ height: '100dvh' }}>
      {/* ヘッダー */}
      <div className="relative bg-[#058bbe] h-[45px] flex items-center justify-center flex-shrink-0">
        <MyNaviTypography variant="points-label" className="leading-none">
          {title}
        </MyNaviTypography>
        <button
          type="button"
          onClick={onClose}
          aria-label="閉じる"
          className="absolute right-[11px] top-1/2 -translate-y-1/2 text-white"
        >
          <IconX size={24} stroke={1.5} />
        </button>
      </div>

      {/* コンテンツ（スクロール可能） */}
      <div className="flex-1 overflow-y-auto">{children}</div>

      {/* フッター */}
      <div className="flex-shrink-0 bg-[#fbfbfb] pb-4 pt-2 px-2">
        {/* ボタン行（items-end で高さ違いのボタンを底部揃え） */}
        <div className="flex gap-2 items-end">
          <div className="flex-[2.6]">
            <MyNaviButton
              label="選択"
              onClick={onSelect}
              showIcon={false}
              resultCount={searchResultCount ?? undefined}
            />
          </div>
          <button
            type="button"
            onClick={onClear}
            className="flex-1 h-[38px] bg-white border border-[#686868] rounded text-[#686868] text-[16px]"
            style={{ fontFamily: "'BIZ UDPGothic', sans-serif" }}
          >
            クリア
          </button>
        </div>
      </div>
    </div>
  )
}
